module.exports = __webpack_public_path__ + "static/factors-affecting-price-featured-132c6d09632dfd9a808198aa3322f2fd.png";